import React from 'react';
import {Router, Route, Redirect, Switch} from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from '../history/history';

import { AuthGuardImpl } from '../components/common/AuthGaurd';
import  Home  from '../components/home/Home';
import About from '../components/about/About';
import Contact from '../components/contact/index';
import ContactDash from '../components/contact/contactDashboard';

import DSAContact from '../components/becomedsa/index';
import DSAContactDash from '../components/becomedsa/contactDashboard';


import Package from '../components/package/index';
import ToastDemo from '../components/common/toaster';
import Signup_Login from '../components/signUp/index';
// import Dashboard from '../components/dashboard/index';
import Campaign from '../components/campaign/CreateCompaign';
import AudioManagement from '../components/audioManagement/audioManagementListComp';
// import AuthGuardImpl from '../components/signUp/authgaurd';
import Dashboard from '../components/campaign/campaignList';
import ComapignSuccess from '../components/campaign/CompaignSuccess';
import {PublicRoute} from '../components/signUp/authgaurd';
import Loader from '../components/common/Loader';

import '../../assets/css/style.scss'
import forget from '../components/signUp/forget';
import ViewCampaign from '../components/campaign/campaignList';
import KycDetail from '../components/campaign/kycDetail';
import TermsAndConditions from '../components/campaign/termsAndConditions';
import SimpleForm from "../components/Widget/chatbot";

import KycDetailsComp from '../components/kyc_details/KycDetailsComp';
import EditKycDetailComp from '../components/kyc_details/EditKycDetails';

import Error from '../components/admin/common/Error';
import contact from '../components/contact/index';
import contactDashboard from '../components/contact/contactDashboard';

//Define User Route
const MainRoutes= ()=> (
  <Router history= {history}>
  <div className="user">
  <Loader/>
  <Error />
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/about" component={About} />
      <Route exact path="/contact" component={Contact} />
      <Route exact path="/tradepartner" component={DSAContact} />
      <Route exact path="/package" component={Package} />
      <Route exact path="/toaster" component={ToastDemo} />
      <PublicRoute exact path="/login" component={Signup_Login} />
      <PublicRoute exact path="/forgot" component={forget} />

      <AuthGuardImpl exact path="/kycdetails" component={KycDetailsComp} />
      <AuthGuardImpl exact path="/updatekycdetails" component={EditKycDetailComp} />
      
      <AuthGuardImpl exact path="/dashboard" component={Dashboard} />
      <AuthGuardImpl exact path="/campaign" component={Campaign} />
      <AuthGuardImpl exact path="/kyc" component={KycDetail} />
      <AuthGuardImpl exact path="/contactUs" component={ContactDash} />
      <AuthGuardImpl exact path="/becomedsaagent" component={DSAContactDash} />
      <AuthGuardImpl exact path="/comapignsuccess" component={ComapignSuccess} />
      <AuthGuardImpl exact path="/campaign/view" component={ViewCampaign} />
      <AuthGuardImpl exact path="/termsandconditions" component={TermsAndConditions} />
      <AuthGuardImpl exact path="/audioManagement" component={AudioManagement} />
    </Switch>
    </div>
  </Router>
)

export default MainRoutes;


// WEBPACK FOOTER //
// ./web/routes/userRoutes.js